// ClientApp/src/apps/components/tests/SsoAuthVerificationFlow/components/ParsedPayloadList.jsx
import PropTypes from "prop-types";
import { formatPayloadValue } from "../utils/niogemsPayload";

export default function ParsedPayloadList({ data }) {
  if (!data) return null;

  return (
    <div className="sso-auth-flow__parsed-payload">
      <h4 className="sso-auth-flow__parsed-payload-title">Parsed Payload Properties</h4>
      <ul className="sso-auth-flow__parsed-payload-list">
        {Object.entries(data).map(([key, value]) => (
          <li key={key} className="sso-auth-flow__parsed-payload-item">
            <strong className="sso-auth-flow__parsed-payload-key">{key}:</strong>{" "}
            <code className="sso-auth-flow__parsed-payload-value">
              {formatPayloadValue(value)}
            </code>
          </li>
        ))}
      </ul>
    </div>
  );
}

ParsedPayloadList.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types -- shape is dynamic API payload
  data: PropTypes.object,
};

ParsedPayloadList.defaultProps = {
  data: null,
};